/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

/**
 * The circular call-control button.
 *
 * Lived twice, byte for byte apart from the name of one colour constant, in
 * SoftphoneDock and CallConsole. The dock and the console are two skins over
 * one engine, so a control that behaves differently between them is a bug by
 * definition; keeping one copy is what makes that true rather than aspirational.
 */

import React from "react";
import { IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import colors from "styles/tokens/colors";

const cc = colors.callCenter;

export default function RoundButton({
  icon,
  label,
  onClick,
  active,
  danger,
  disabled,
  size = 48,
}) {
  return (
    <MDBox display="flex" flexDirection="column" alignItems="center" gap={0.5}>
      <IconButton
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
        aria-pressed={active ? true : undefined}
        sx={{
          width: size,
          height: size,
          bgcolor: danger ? cc.danger : active ? cc.activeBackground : cc.surface,
          color: danger ? "#fff" : active ? cc.activeText : cc.muted,
          "&:hover": {
            bgcolor: danger
              ? cc.dangerHover
              : active
              ? cc.activeHover
              : cc.surfaceHover,
          },
          "&.Mui-disabled": { bgcolor: cc.surface, color: cc.disabled },
        }}
      >
        {icon}
      </IconButton>
      {label ? (
        <MDTypography variant="caption" color="text" sx={{ fontSize: "0.65rem" }}>
          {label}
        </MDTypography>
      ) : null}
    </MDBox>
  );
}
